import { useContext } from 'react';

import { InvertThemeContext } from '../components/InvertTheme';

export const useThemeIsInverted = () => {
  const { inverted } = useContext(InvertThemeContext);
  return inverted;
};
